// routes/QuizRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import QuizSettingsPage from "../pages/QuizPages/QuizSettings";
import QuizPage from "../pages/QuizPages/QuizPage";
import QuizResultsPage from "../pages/QuizPages/QuizResults";
import ProtectedQuizRoute from "../components/ProtectedQuizRoute";
import { ManagerQuizPage } from "../pages/QuizPages/ManagerQuizPage";
import { UserQuizSettingsPage } from "../pages/ManagerPortalPages/UserQuizSettings";
import AddProficiency from "../pages/Profile/AddProficiency";
import QuizResultsForDashboard from "../pages/QuizPages/QuizResultsForDashborad";
import ProtectedRouteWithUserCheck from "./utils/ProtectedRouteWithUserCheck";

const QuizRoutes = (
  <>
    <Route element={<ProtectedQuizRoute />}>
      <Route
        path="/:user_id/assessment/:assessment_id"
        element={<QuizPage />}
      ></Route>
    </Route>
    <Route
      path="/:user_id/manager-assessment/:assessment_id"
      element={<ManagerQuizPage />}
    />

    <Route
      path="/:user_id/quiz-settings-manager/:assessment_id"
      element={<UserQuizSettingsPage />}
    />
    <Route
      path="/assessment-quiz-result/:user_id/:assessment_id"
      element={<QuizResultsPage />}
    />
    <Route path="/add-proficiency/:user_id" element={
      <ProtectedRouteWithUserCheck>
        <AddProficiency />
      </ProtectedRouteWithUserCheck>
    } />

    <Route path="/quiz-settings" element={<QuizSettingsPage />} />
    {/* <Route path="/quiz-results/:user_id" element={<QuizResultsPage />} /> */}
    <Route
      path="/quiz-results/:user_id"
      element={<ProtectedRouteWithUserCheck> <QuizResultsForDashboard /> </ProtectedRouteWithUserCheck>}
    />
    {/* Add other quiz-related routes here */}
  </>
);

export default QuizRoutes;
